import React from 'react'

import { Procedure } from '../../../utils/eventUtils'

interface IToggleProps {
  id: string
  title: string
  isChecked: boolean
  onChange?: Procedure
  isDisabled: boolean
}

export const Toggle = (props: IToggleProps) => {
  return (
    <>
      <span className="set-lst__lb" id={props.id}>
        {props.title}
      </span>
      <span className="toggle">
        <input
          type="checkbox"
          id="auto"
          className="toggle__ipt"
          checked={props.isChecked}
          aria-labelledby={props.id}
          onChange={props.onChange}
          disabled={props.isDisabled}
        />
        <label htmlFor="auto" className="toggle__ui"></label>
      </span>
    </>
  )
}
